// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_TO_STRING = "toString"; // Count: 4
export var _DYN_IS_STORAGE_USE_DISAB0 = "isStorageUseDisabled"; // Count: 3
export var _DYN__ADD_HOOK = "_addHook"; // Count: 6
export var _DYN_CORE = "core"; // Count: 13
export var _DYN_DIAG_LOG = "diagLog"; // Count: 13
export var _DYN_TRACK = "track"; // Count: 7
export var _DYN_TRACK_PAGE_VIEW = "trackPageView"; // Count: 4
export var _DYN_CONFIG = "config"; // Count: 12
export var _DYN_TRACK_PREVIOUS_PAGE_1 = "trackPreviousPageVisit"; // Count: 3
export var _DYN_SEND_PAGE_VIEW_INTER2 = "sendPageViewInternal"; // Count: 7
export var _DYN_REF_URI = "refUri"; // Count: 5
export var _DYN_START_TIME = "startTime"; // Count: 6
export var _DYN_PROPERTIES = "properties"; // Count: 5
export var _DYN_DURATION = "duration"; // Count: 12
export var _DYN_SEND_PAGE_VIEW_PERFO3 = "sendPageViewPerformanceInternal"; // Count: 3
export var _DYN_POPULATE_PAGE_VIEW_P4 = "populatePageViewPerformanceEvent"; // Count: 2
export var _DYN_HREF = "href"; // Count: 6
export var _DYN_SEND_EXCEPTION_INTER5 = "sendExceptionInternal"; // Count: 2
export var _DYN_ERROR = "error"; // Count: 5
export var _DYN_LINE_NUMBER = "lineNumber"; // Count: 4
export var _DYN_COLUMN_NUMBER = "columnNumber"; // Count: 5
export var _DYN__CREATE_AUTO_EXCEPTI6 = "CreateAutoException"; // Count: 3
export var _DYN_ADD_TELEMETRY_INITIA7 = "addTelemetryInitializer"; // Count: 4
export var _DYN_OVERRIDE_PAGE_VIEW_D8 = "overridePageViewDuration"; // Count: 2
export var _DYN_AUTO_EXCEPTION_INSTR9 = "autoExceptionInstrumented"; // Count: 3
export var _DYN_AUTO_TRACK_PAGE_VISI10 = "autoTrackPageVisitTime"; // Count: 2
export var _DYN_IS_BROWSER_LINK_TRAC11 = "isBrowserLinkTrackingEnabled"; // Count: 2
export var _DYN_LENGTH = "length"; // Count: 5
export var _DYN_ENABLE_AUTO_ROUTE_TR12 = "enableAutoRouteTracking"; // Count: 2
export var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
export var _DYN_ENABLE_UNHANDLED_PRO13 = "enableUnhandledPromiseRejectionTracking"; // Count: 2
export var _DYN_AUTO_UNHANDLED_PROMI14 = "autoUnhandledPromiseInstrumented"; // Count: 3
export var _DYN_GET_ENTRIES_BY_TYPE = "getEntriesByType"; // Count: 5
export var _DYN_IS_PERFORMANCE_TIMIN15 = "isPerformanceTimingSupported"; // Count: 2
export var _DYN_GET_PERFORMANCE_TIMI16 = "getPerformanceTiming"; // Count: 2
export var _DYN_NAVIGATION_START = "navigationStart"; // Count: 4
export var _DYN_SHOULD_COLLECT_DURAT17 = "shouldCollectDuration"; // Count: 2
export var _DYN_IS_PERFORMANCE_TIMIN18 = "isPerformanceTimingDataReady"; // Count: 2
export var _DYN_RESPONSE_START = "responseStart"; // Count: 5
export var _DYN_REQUEST_START = "requestStart"; // Count: 3
export var _DYN_LOAD_EVENT_END = "loadEventEnd"; // Count: 4
export var _DYN_RESPONSE_END = "responseEnd"; // Count: 5
export var _DYN_CONNECT_END = "connectEnd"; // Count: 4
export var _DYN_PAGE_VISIT_TIME = "pageVisitTime"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map